export default __webpack_public_path__ + "static/media/Dayforce.f8483a16.svg";